import { Pipe, PipeTransform } from "@angular/core";
import { DocumentModel } from "../../../ek-e-commerce/ek-models/document.model";

@Pipe({
  name: "getIdByTitle",
})
export class GetIdByTitlePipe implements PipeTransform {
  transform(value: DocumentModel[], documentTitle: string): number {
    let id = 0;
    if (value) {
      let obj = value.find((o) => o.documentsTitle === documentTitle);
      id = obj?.id!;
    }
    return id;
  }
}
